"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgDollarOutlined = function SvgDollarOutlined(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "theme", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("circle", {
      cx: "10",
      cy: "10",
      r: "9",
      stroke: fill || theme.colors.primary.main,
      strokeWidth: "2"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M10.3839 11.0127C11.3757 11.2832 11.7148 11.5815 11.7148 12.1711C11.7148 12.7884 11.2733 13.2116 10.3839 13.2948V11.0127ZM9.64808 8.93873C8.79068 8.68902 8.41956 8.3422 8.41956 7.80116C8.41956 7.26012 8.84186 6.82312 9.64808 6.72601V8.93873ZM10.3839 9.11908V6.73295C11.1005 6.84393 11.5804 7.26705 11.67 8.00231H13.3784C13.3208 6.35145 12.1627 5.26243 10.3839 5.11676V4H9.64808V5.11676C7.88848 5.23468 6.62797 6.3237 6.62797 7.98844C6.62797 9.50058 7.54936 10.3191 9.21938 10.7283L9.64808 10.8324V13.2948C8.77788 13.1977 8.32358 12.7191 8.21481 12.0324H6.5C6.55119 13.7665 7.85009 14.7931 9.64808 14.911V16H10.3839V14.904C12.2011 14.7653 13.5 13.6971 13.5 11.9491C13.5 10.4231 12.585 9.65318 10.8382 9.23006L10.3839 9.11908Z",
      fill: fill || theme.colors.primary.main
    })]
  }));
};

var _default = SvgDollarOutlined;
exports["default"] = _default;